import React, { createContext, useCallback, useContext, useState } from "react";
import getId from "utils/getId";

type Notification = {
  // only error type for now
  type: "error";
  message: string;
  id: string;
};
type Context = {
  notifications: Notification[];
  addNotification: (arg: Omit<Notification, "id">) => void;
  removeNotification: (arg: Notification) => void;
};

export const CalendarNotificationsContext = createContext<Context>({
  notifications: [],
  addNotification: () => null,
  removeNotification: () => null,
});

export const CalendarNotificationsContextProvider = ({ children }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const addNotification = useCallback<Context["addNotification"]>((arg) => {
    setNotifications((s) => [...s, { ...arg, id: getId("notification") }]);
  }, []);

  const removeNotification = useCallback<Context["removeNotification"]>(
    (arg) => {
      setNotifications((s) => {
        const index = s.indexOf(arg);

        if (index < 0) {
          return s;
        }

        return [...s.slice(0, index), ...s.slice(index + 1)];
      });
    },
    [],
  );
  return (
    <CalendarNotificationsContext.Provider
      value={{
        notifications,
        addNotification,
        removeNotification,
      }}
    >
      {children}
    </CalendarNotificationsContext.Provider>
  );
};

export const useCalendarNotifications = () =>
  useContext(CalendarNotificationsContext);
